import { classnames, ProgressTracker, ProgressTrackerStep } from '@terveystalo/design-system-react-components';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

// Progressbar above the questionary
type Props = {
  currentStep: 1 | 2 | 3;
};
export const ProgressBar: FC<Props> = ({ currentStep }) => {
  const { t } = useTranslation();
  const steps: ProgressTrackerStep[] = [
    { key: 1, label: t('step_your_symptoms') },
    { key: 2, label: t('step_questions') },
    { key: 3, label: t('step_summary') },
  ];

  return (
    <div className={classnames('flex', 'mb-1')}>
      <ProgressTracker label="progress-tracker" currentStepKey={currentStep} steps={steps} />
    </div>
  );
};
